<template>
	<div class="mobile">
		<div class="mobile-study">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-if="courseTotal > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
					<van-cell class="list" v-for="item in courseList" :key="item.id">
						<div style="display: flex; justify-content: space-between">
							<div class="mobile-study-title">
								{{ item.goodsName }}
							</div>
							<div>
								<h2 class="notLearning" v-if="item.studyStatus == '039001'"><span>未学习</span></h2>
								<h2 class="isLearning" v-if="item.studyStatus == '039002'"><span>学习中</span></h2>
								<h2 class="finishedLearning" v-if="item.studyStatus == '039003'"><span>已学完</span></h2>
							</div>
						</div>
						<div class="textImage_he">
							<div>学习时间:{{ item.studyStartTime | formatDate }}-{{ item.studyEndTime | formatDate }}</div>
							<span class="period"> 考核学时:{{ item.testHours }} </span>
						</div>
						<!-- 进度条 -->
						<div class="progress" style="display: flex; align-items: center">
							<van-progress
								:show-pivot="false"
								style="width: 5.946667rem"
								:percentage="(parseFloat(item.studyPercent))"
								stroke-width="4"
								track-color="#e1e1e1"
								color="#dc0021"
							/><span>已学{{ parseFloat(item.studyPercent)}}%</span>
						</div>
						<div class="mobile-study-btn">
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039001'"
								type="danger"
								:to="{ path: '/mobileClass', query: { id: item.goodsId } }"
								>开始学习</van-button
							>
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039002'"
								type="danger"
								:to="{ path: '/mobileClass', query: { id: item.goodsId } }"
								>继续学习</van-button
							>
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039003'"
								type="danger"
								:to="{ path: '/mobileClass', query: { id: item.goodsId } }"
								>已学完</van-button
							>
							<van-button
								:color="item.studyStatus == '039003' ? '' : '#9f9f9f'"
								@click="learningArchives(item.goodsId, item.studyStatus)"
								round
								size="small"
								plain
								type="danger"
								>学习档案</van-button
							>
							<van-button
								:color="item.studyStatus == '039003' ? '' : '#9f9f9f'"
								@click="getCertificate(item.goodsId, item.studyStatus)"
								round
								size="small"
								plain
								type="danger"
								>结业证书</van-button
							>
						</div>
					</van-cell>
				</van-list>
				<van-list v-else>
					<div class="myClass">我的班级</div>
					<van-empty class="custom-image" image="../../../static/images/mobile/examclass.png" description="暂无班级" />
				</van-list>
			</van-pull-refresh>
		</div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
export default {
	data() {
		return {
			active: 1,
			courseList: [],
			pageNumber: 0,
			pageSize: "",
			loading: false,
			finished: false,
			refreshing: false,
			types: "016005",
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			courseTotal: "",
			Incomplete: false,
		};
	},
	methods: {
		accMul(arg1, arg2) {
			var m = 0,
				s1 = arg1.toString(),
				s2 = arg2.toString();
			try {
				m += s1.split(".")[1].length;
			} catch (e) {}
			try {
				m += s2.split(".")[1].length;
			} catch (e) {}
			return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
		},
		onLoad() {
			this.pageNumber++;
			let pageSize = this.pageSize;
			let pageNumber = this.pageNumber;
			let types = this.types;
			let params = {};
			params.pageSize = pageSize;
			params.pageNumber = pageNumber;
			params.types = types;
			this.$axiosPackag.getMessageByAxios("GET", "/userStudyResource/myStudyData", params, null, null, (resD) => {
				if (resD) {
					for (let i = 0; i < resD.rows.length; i++) {
						if (!this.$util.isBlackStr(resD.rows[i].goodsDesc)) {
							let textDesc = this.$util.html(resD.rows[i].goodsDesc);
							textDesc = this.$util.filterHtmlTag(textDesc);
							if (!this.$util.isBlackStr(textDesc)) {
								if (textDesc.length > 20) {
									textDesc = textDesc.substr(0, 20) + "...";
								}
							}
							resD.rows[i].goodsDesc = textDesc;
						}
						if (resD.rows[i].studyPercent) {
							resD.rows[i].studyPercent = this.accMul(resD.rows[i].studyPercent, 100);
						} else {
							resD.rows[i].studyPercent = 0;
						}
						resD.rows[i].firstCate = "";
						if (null != resD.rows[i].categoryInfoList && resD.rows[i].categoryInfoList.length > 0) {
							let firstCate = "";
							for (let j = 0; resD.rows[i].categoryInfoList.length; j++) {
								if (resD.rows[i].categoryInfoList[j].pid == 0) {
									firstCate = resD.rows[i].categoryInfoList[j].name;
									break;
								}
							}
							resD.rows[i].firstCate = firstCate;
						}
					}
					this.courseList = this.courseList.concat(resD.rows);
					this.courseTotal = resD.total;
					// 加载状态结束
					this.loading = false;
					if (this.courseList.length == resD.total) {
						// 数据全部加载完成
						this.finished = true;
					}
				}
			});
		},
		onRefresh() {
			// 清空列表数据
			this.finished = false;

			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.onLoad();
		},
		cannelGoBack() {
			this.$router.go(-1);
		},
		//学习档案
		learningArchives(id, studyStatus) {
			if (studyStatus == "039003") {
				const userId = this.$sessionStore.getUserId();
				const goodsPackageId = id;
				window.open("/courseRecord/classLearningFileForPHP?userId=" + userId + "&goodsPackageId=" + goodsPackageId);
			} else {
				Toast("班级课程学习未完成");
			}
		},
		//结业证书
		getCertificate(id, studyStatus) {
			if (studyStatus == "039003") {
				const userId = this.$sessionStore.getUserId();
				const goodsPackageId = id;
				window.open("/web/certificatePrintPHPForPackage?userId=" + userId + "&goodsPackageId=" + goodsPackageId);
			} else {
				Toast("班级课程学习未完成");
			}
		},
	},
	mounted() {
		this.onLoad();
		// this.active = this.$route.query.active;
	},
	created() {},
	components: {},
	//时间戳转换
	filters: {
		formatDate: function (value) {
			let date = new Date(value);
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? "0" + MM : MM;
			let d = date.getDate();
			d = d < 10 ? "0" + d : d;
			return y + "年" + MM + "月" + d + "日";
		},
	},
};
</script>
<style >
.van-list .custom-image .van-empty__image {
	width: 6.026667rem;
	height: 3.146667rem;
}
</style>
<style scoped>
.mobile-study .list {
	box-shadow: 0px 12px 40px rgba(216, 216, 216, 0.49);
}
.mobile-study .mobile-study-title {
	margin-top: 0.426667rem;
	margin-left: 0.426667rem;
	font-weight: bold;
	font-size: 0.426667rem;
	margin-bottom: 0.32rem;
}
.textImage_he {
	margin-left: 0.426667rem;
	margin-bottom: 0.72rem;
	font-weight: 400;
	color: #555555;
	font-size: 0.346667rem;
}
.textImage_he div {
	margin-bottom: 0.106667rem;
}
.mobile-study-btn {
	margin-top: 0.8rem;
	margin-bottom: 0.426667rem;
}
.mobile-study-btn .van-button {
	font-size: 0.373333rem;
	width: 2.346667rem;
	height: 0.853333rem;
}
.mobile-study-btn .van-button:first-child {
	margin-left: 0.426667rem;
	margin-right: 0.45rem;
}
.mobile-study-btn .van-button:nth-child(2) {
	margin-right: 0.45rem;
}
.progress {
	margin-left: 0.426667rem;
}
.progress span {
	font-size: 0.32rem;
	margin-left: 0.106667rem;
}
.notLearning {
	background-color: #fff1f0;
	color: #f5222d;
	width: 1.44rem;
	height: 0.533333rem;
	font-size: 0.293333rem;
	text-align: center;
	font-weight: 400;
	line-height: 0.533333rem;
	opacity: 1;
	margin-top: 0.106667rem;
	margin-right: 0.106667rem;
	border-radius: 0.053333rem;
}
.isLearning {
	background-color: #e6f7ff;
	color: #1890ff;
	width: 1.44rem;
	height: 0.533333rem;
	font-size: 0.293333rem;
	text-align: center;
	font-weight: 400;
	line-height: 0.533333rem;
	opacity: 1;
	margin-top: 0.106667rem;
	margin-right: 0.106667rem;
	border-radius: 0.053333rem;
}
.finishedLearning {
	background-color: #f6ffed;
	color: #52c41a;
	width: 1.44rem;
	height: 0.533333rem;
	font-size: 0.293333rem;
	text-align: center;
	font-weight: 400;
	line-height: 0.533333rem;
	opacity: 1;
	margin-top: 0.106667rem;
	margin-right: 0.106667rem;
	border-radius: 0.053333rem;
}
.list {
	border-radius: 0.106667rem;
}
.myClass {
	margin-top: 0.293333rem;
	margin-bottom: 3.386667rem;
	text-align: center;
	height: 0.586667rem;
	font-size: 0.426667rem;
	font-weight: bold;
	line-height: 0.586667rem;
	color: #000000;
	opacity: 1;
}
.custom-image .van-empty__image {
	width: 90px;
	height: 90px;
}
</style>


// WEBPACK FOOTER //
// MobileStudy.vue?3b5bcac6